import UpdateContainer from "../../../../components/@repositories/containers/UpdateContainer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ContainerUpdatePage() {

    return (
        <UpdateContainer 
            routeType={routeTypes.admin}
        />
    )
}